import { call, put, takeLatest } from 'redux-saga/effects';
import notification from '../../services/notification';
import api from '../../services/api';
import types from '../types';

function* getOrders({ payload }) {
  try {
    const { status, data } = yield call(api.orders.getOrders, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_ORDERS_SUCCESS, payload: data.data });
  } catch (error) {
    yield put({ type: types.GET_ORDERS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

export function* orders() {
  yield takeLatest(types.GET_ORDERS_START, getOrders);
}
